import { EnumElementStatus } from '../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumElementStatus';
import { APP } from '../../../../../api/com/MetaPattern/MDA/MD/Base/APP';
import { BaseComponent } from '../../../../../api/com/MetaPattern/MDA/MD/Base/BaseComponent';

/** IDE中的应用树结构 */
export class APPTree {
  id: string;
  status: EnumElementStatus;
  /** APPKey : APPKey应用的唯一标识，全局唯一 */
  aPPKey: string;
  /** 根名字空间 : 根名字空间 */
  rootNamespace: string;
  /** 设计期ID : 设计期ID */
  designId: string;
  /** 名称 : 元数据名称 */
  name: string;
  /** 显示名称 : 元数据的显示名称 */
  displayName: string;
  /** 描述 : 元数据的描述 */
  description: string;
  /** 应用 */
  app: APP;
  /** 组件 */
  components: Array<BaseComponent>;

  constructor(app: APP) {
    this.app = app;
    this.id = app.id;
    this.status = app.status;
    this.designId = app.designId;
    this.name = app.name;
    this.displayName = app.displayName;
    this.description = app.description;
    this.aPPKey = app.aPPKey;
    this.rootNamespace = app.rootNamespace;
    this.components = new Array<BaseComponent>();
    app.aPPComponents.forEach((aPPComponent) => {
      this.components.push(aPPComponent as BaseComponent);
    });
    app.bEComponents.forEach((bEComponent) => {
      this.components.push(bEComponent as BaseComponent);
    });
    app.dBComponents.forEach((dBComponent) => {
      this.components.push(dBComponent as BaseComponent);
    });
    app.uIModelComponents.forEach((uIModelComponent) => {
      this.components.push(uIModelComponent as BaseComponent);
    });
  }
}
